import { AppConfiguration, EnvConfiguration } from "./AppConfiguration";
import { development } from "./development";
import { localhost } from "./localhost";
import { production } from "./production";
import { staging } from "./staging";

const getEnvConfiguration = (env?: string): EnvConfiguration => {
    switch (env) {
        case "development":
            return development;
        case "staging":
            return staging;
        case "production":
            return production;
        default:
            return production;
    }
};

export const configuration: AppConfiguration = {
    ...getEnvConfiguration(import.meta.env.VITE_STAGE),
};
